export default "__VITE_ASSET__4m0b36IP__"